import React, { useEffect, useRef } from "react";
import { PagerProps } from "../../types/pager";
import { usePageContext } from "../../util/context";
import ChevronRight from "../../assets/chevron-right-icon";
import "./pager.scss";

const Pager = (props: PagerProps) => {
  const leftPagerButtonRef = useRef<HTMLButtonElement>(null);
  const rightPagerButtonRef = useRef<HTMLButtonElement>(null);
  const { pageCount, currentPage, goToNextPage, goToPreviousPage } = usePageContext();
  const disableLeftButton = currentPage === 1;
  const disableRightButton = currentPage === pageCount;
  const buttonTabNavAttribute = { focusable: true };

  const getButtonLabel = (isPrevious: boolean) => {
    const pagingText = props.l10n.pageOfPages
      .replace("{1}", currentPage.toString())
      .replace("{2}", pageCount.toString());
    const buttonAction = isPrevious ? props.l10n.previousArticlePage : props.l10n.nextArticlePage;
    return pagingText + ", " + buttonAction;
  };

  useEffect(() => {
    if (disableLeftButton && disableRightButton) return;

    if (disableLeftButton && leftPagerButtonRef.current?.classList.contains("has-focus-keyboard")) {
      shell?.tabNav.focus(rightPagerButtonRef.current as Element, "keyboard");
    } else if (
      disableRightButton &&
      rightPagerButtonRef.current?.classList.contains("has-focus-keyboard")
    ) {
      shell?.tabNav.focus(leftPagerButtonRef.current as Element, "keyboard");
    }
  }, [disableLeftButton, disableRightButton]);

  return (
    <div className="pager-container">
      <div className="pager-content">
        <button
          ref={leftPagerButtonRef}
          className="chevron-left-button"
          disabled={disableLeftButton}
          aria-label={getButtonLabel(true)}
          onClick={goToPreviousPage}
          data-semantic-id="product-recommendation-carousel-arrows-previous"
          data-product-recommendation-fragment={props.dataFragmentName}
          {...buttonTabNavAttribute}
        >
          <ChevronRight />
        </button>

        <div className="pager-values">
          <span>
            {currentPage}/{pageCount}
          </span>
        </div>

        <button
          ref={rightPagerButtonRef}
          className="chevron-right-button"
          disabled={disableRightButton}
          aria-label={getButtonLabel(false)}
          onClick={goToNextPage}
          data-semantic-id="product-recommendation-carousel-arrows-next"
          data-product-recommendation-fragment={props.dataFragmentName}
          {...buttonTabNavAttribute}
        >
          <ChevronRight />
        </button>
      </div>
    </div>
  );
};

export default Pager;
